app.controller('ErrorCtrl', ["$scope", function($scope) {
  $scope.globalError = window.globalError;
}]);
